export class EnvConfig {
    static SITE_ROOT_URL = 'https://p.kkosa.ru/';
    static PLATFORM = 'web'; // android, ios, web
}